import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	connect() {
		console.log('initLearning');

		let left: string[], right: string[], count: number, row: number;
		let state = 0;

		$('#btnGo').on('click', function () {
			switch (state) {
				case 0:
					left = String($('#learn_left').val() ?? '').split('\n');
					right = String($('#learn_right').val() ?? '').split('\n');
					count = Math.min(left.length, right.length);
					$('form.learn').hide();
					nextQuestion();
					state = 1;
					break;
				case 1:
					nextAnswer();
					state = 2;
					break;
				case 2:
					nextQuestion();
					state = 1;
					break;
			}
		});

		function nextQuestion() {
			row = Math.floor(Math.random() * count);
			$('#leftWord').text(left[row]);
			$('#rightWord').text('');
		}

		function nextAnswer() {
			$('#rightWord').text(right[row]);
		}

	}
}

